import { useEffect } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";

export default function Fancybox({ children }) {
  useEffect(() => {
    NativeFancybox.bind("[data-fancybox]", {
      Thumbs: false,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ["close"],
        },
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);

  return <>{children}</>;
}